
var callWithJQuery,
  indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; },
  slice = [].slice,
  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
  hasProp = {}.hasOwnProperty;
  console.log('Loading Pivot Lib')

  /*
   Utilities
   */
  var PivotData;
  var	addSeparators,
    aggregatorTemplates,
    aggregators, dayNamesEn,
    derivers, getSort, locales,
    mthNamesEn, naturalSort,
    numberFormat, pivotTableRenderer,
    rd, renderers, rx, rz, sortAs,
    usFmt, usFmtInt, usFmtPct, zeroPad;

  //Ajouter séparateur pour les nombres avec virgule
  addSeparators = function(nStr, thousandsSep, decimalSep) {
    var rgx, x, x1, x2;
    nStr += '';
    x = nStr.split('.');
    x1 = x[0];
    x2 = x.length > 1 ? decimalSep + x[1] : '';
    rgx = /(\d+)(\d{3})/;
    while (rgx.test(x1)) {
      x1 = x1.replace(rgx, '$1' + thousandsSep + '$2');
    }
    return x1 + x2;
  };
  // Format d'affichage des chiffres
  numberFormat = function(opts) {
    var defaults;
    defaults = {
      digitsAfterDecimal: 2,
      scaler: 1,
      thousandsSep: ",",
      decimalSep: ".",
      prefix: "",
      suffix: ""
    };
    opts = $.extend({}, defaults, opts);
    return function(x) {
      var result;
      if (isNaN(x) || !isFinite(x)) {
        return "";
      }
      result = addSeparators((opts.scaler * x).toFixed(opts.digitsAfterDecimal), opts.thousandsSep, opts.decimalSep);
      return "" + opts.prefix + result + opts.suffix;
    };
  };

  // Default format chiffre
  usFmt = numberFormat();

  // format 2
  usFmtInt = numberFormat({
    digitsAfterDecimal: 0
  });

  // format pour les pourcentages
  usFmtPct = numberFormat({
    digitsAfterDecimal: 1,
    scaler: 100,
    suffix: "%"
  });

  // les fonctions d'aggrégation
  aggregatorTemplates = {
    // Compter le nombre d'occurences
    count: function(formatter) {
      if (formatter == null) {
        formatter = usFmtInt;
      }
      return function() {
        return function(data, rowKey, colKey) {
          return {
            count: 0,
            push: function() {
              return this.count++;
            },
            value: function() {
              return this.count;
            },
            format: formatter
          };
        };
      };
    },
    uniques: function(fn, formatter) {
      if (formatter === null) {
        formatter = usFmtInt;
      }
      return function(arg) {
        var attr;
        attr = arg[0];
        return function(data, rowKey, colKey) {
          return {
            uniq: [],
            push: function(record) {
              var ref;
              if (ref = record[attr], indexOf.call(this.uniq, ref) < 0) {
                return this.uniq.push(record[attr]);
              }
            },
            value: function() {
              return fn(this.uniq);
            },
            format: formatter,
            numInputs: attr != null ? 0 : 1
          };
        };
      };
    },
    // La sommes des valeurs
    sum: function(formatter) {
      if (formatter == null) {
        formatter = usFmt;
      }
      return function(arg) {
        var attr;
        attr = arg[0];
        return function(data, rowKey, colKey) {
          return {
            sum: 0,
            push: function(record) {
              if (!isNaN(parseFloat(record[attr]))) {
                return this.sum += parseFloat(record[attr]);
              }
            },
            value: function() {
              return this.sum;
            },
            format: formatter,
            numInputs: attr != null ? 0 : 1
          };
        };
      };
    },
    // Les autres fonctions
    extremes: function(mode, formatter) {
      if (formatter == null) {
        formatter = usFmt;
      }
      return function(arg) {
        var attr;
        attr = arg[0];
        return function(data, rowKey, colKey) {
          return {
            val: null,
            sorter: getSort(data != null ? data.sorters : void 0, attr),
            push: function(record) {
              var ref, ref1, ref2, x;
              x = record[attr];
              if (mode === "min" || mode === "max") {
                x = parseFloat(x);
                if (!isNaN(x)) {
                  this.val = Math[mode](x, (ref = this.val) != null ? ref : x);
                }
              }
              if (mode === "first") {
                if (this.sorter(x, (ref1 = this.val) != null ? ref1 : x) <= 0) {
                  this.val = x;
                }
              }
              if (mode === "last") {
                if (this.sorter(x, (ref2 = this.val) != null ? ref2 : x) >= 0) {
                  return this.val = x;
                }
              }
            },
            value: function() {
              return this.val;
            },
            format: function(x) {
              if (isNaN(x)) {
                return x;
              } else {
                return formatter(x);
              }
            },
            numInputs: attr != null ? 0 : 1
          };
        };
      };
    },
    quantile: function(q, formatter) {
      if (formatter == null) {
        formatter = usFmt;
      }
      return function(arg) {
        var attr;
        attr = arg[0];
        return function(data, rowKey, colKey) {
          return {
            vals: [],
            push: function(record) {
              var x;
              x = parseFloat(record[attr]);
              if (!isNaN(x)) {
                return this.vals.push(x);
              }
            },
            value: function() {
              var i;
              if (this.vals.length === 0) {
                return null;
              }
              this.vals.sort(function(a, b) {
                return a - b;
              });
              i = (this.vals.length - 1) * q;
              return (this.vals[Math.floor(i)] + this.vals[Math.ceil(i)]) / 2.0;
            },
            format: formatter,
            numInputs: attr != null ? 0 : 1
          };
        };
      };
    },
    runningStat: function(mode, ddof, formatter) {
      if (mode == null) {
        mode = "mean";
      }
      if (ddof == null) {
        ddof = 1;
      }
      if (formatter == null) {
        formatter = usFmt;
      }
      return function(arg) {
        var attr;
        attr = arg[0];
        return function(data, rowKey, colKey) {
          return {
            n: 0.0,
            m: 0.0,
            s: 0.0,
            push: function(record) {
              var m_new, x;
              x = parseFloat(record[attr]);
              if (isNaN(x)) {
                return;
              }
              this.n += 1.0;
              if (this.n === 1.0) {
                return this.m = x;
              } else {
                m_new = this.m + (x - this.m) / this.n;
                this.s = this.s + (x - this.m) * (x - m_new);
                return this.m = m_new;
              }
            },
            value: function() {
              if (mode === "mean") {
                if (this.n === 0) {
                  return 0 / 0;
                } else {
                  return this.m;
                }
              }
              if (this.n <= ddof) {
                return 0;
              }
              switch (mode) {
                case "var":
                  return this.s / (this.n - ddof);
                case "stdev":
                  return Math.sqrt(this.s / (this.n - ddof));
              }
            },
            format: formatter,
            numInputs: attr != null ? 0 : 1
          };
        };
      };
    },
    sumOverSum: function(formatter) {
      if (formatter == null) {
        formatter = usFmt;
      }
      return function(arg) {
        var denom, num;
        num = arg[0], denom = arg[1];
        return function(data, rowKey, colKey) {
          return {
            sumNum: 0,
            sumDenom: 0,
            push: function(record) {
              if (!isNaN(parseFloat(record[num]))) {
                this.sumNum += parseFloat(record[num]);
              }
              if (!isNaN(parseFloat(record[denom]))) {
                return this.sumDenom += parseFloat(record[denom]);
              }
            },
            value: function() {
              return this.sumNum / this.sumDenom;
            },
            format: formatter,
            numInputs: (num != null) && (denom != null) ? 0 : 2
          };
        };
      };
    },
    sumOverSumBound80: function(upper, formatter) {
      if (upper == null) {
        upper = true;
      }
      if (formatter == null) {
        formatter = usFmt;
      }
      return function(arg) {
        var denom, num;
        num = arg[0], denom = arg[1];
        return function(data, rowKey, colKey) {
          return {
            sumNum: 0,
            sumDenom: 0,
            push: function(record) {
              if (!isNaN(parseFloat(record[num]))) {
                this.sumNum += parseFloat(record[num]);
              }
              if (!isNaN(parseFloat(record[denom]))) {
                return this.sumDenom += parseFloat(record[denom]);
              }
            },
            value: function() {
              var sign;
              sign = upper ? 1 : -1;
              return (0.821187207574908 / this.sumDenom + this.sumNum / this.sumDenom + 1.2815515655446004 * sign * Math.sqrt(0.410593603787454 / (this.sumDenom * this.sumDenom) + (this.sumNum * (1 - this.sumNum / this.sumDenom)) / (this.sumDenom * this.sumDenom))) / (1 + 1.642374415149816 / this.sumDenom);
            },
            format: formatter,
            numInputs: (num != null) && (denom != null) ? 0 : 2
          };
        };
      };
    },
    fractionOf: function(wrapped, type, formatter) {
      if (type == null) {
        type = "total";
      }
      if (formatter == null) {
        formatter = usFmtPct;
      }
      return function() {
        var x;
        x = 1 <= arguments.length ? slice.call(arguments, 0) : [];
        return function(data, rowKey, colKey) {
          return {
            selector: {
              total: [[], []],
              row: [rowKey, []],
              col: [[], colKey]
            }[type],
            inner: wrapped.apply(null, x)(data, rowKey, colKey),
            push: function(record) {
              return this.inner.push(record);
            },
            format: formatter,
            value: function() {
              return this.inner.value() / data.getAggregator.apply(data, this.selector).inner.value();
            },
            numInputs: wrapped.apply(null, x)().numInputs
          };
        };
      };
    }
  };

  aggregatorTemplates.countUnique = function(f) {
    return aggregatorTemplates.uniques((function(x) {
      return x.length;
    }), f);
  };
  aggregatorTemplates.listUnique = function(s) {
    return aggregatorTemplates.uniques((function(x) {
      return x.sort(naturalSort).join(s);
    }), (function(x) {
      return x;
    }));
  };
  aggregatorTemplates.max = function(f) {
    return aggregatorTemplates.extremes('max', f);
  };
  aggregatorTemplates.min = function(f) {
    return aggregatorTemplates.extremes('min', f);
  };
  aggregatorTemplates.first = function(f) {
    return aggregatorTemplates.extremes('first', f);
  };
  aggregatorTemplates.last = function(f) {
    return aggregatorTemplates.extremes('last', f);
  };
  aggregatorTemplates.median = function(f) {
    return aggregatorTemplates.quantile(0.5, f);
  };
  aggregatorTemplates.average = function(f) {
    return aggregatorTemplates.runningStat("mean", 1, f);
  };
  aggregatorTemplates["var"] = function(ddof, f) {
    return aggregatorTemplates.runningStat("var", ddof, f);
  };
  aggregatorTemplates.stdev = function(ddof, f) {
    return aggregatorTemplates.runningStat("stdev", ddof, f);
  };

  aggregators = (function(tpl) {
    return {
      "Compter": tpl.count(usFmtInt),
      "Count": tpl.count(usFmtInt),
      "Count Unique Values": tpl.countUnique(usFmtInt),
      "List Unique Values": tpl.listUnique(", "),
      "Sum": tpl.sum(usFmt),
      "Integer Sum": tpl.sum(usFmtInt),
      "Average": tpl.average(usFmt),
      "Median": tpl.median(usFmt),
      "Sample Variance": tpl["var"](1, usFmt),
      "Sample Standard Deviation": tpl.stdev(1, usFmt),
      "Minimum": tpl.min(usFmt),
      "Maximum": tpl.max(usFmt),
      "First": tpl.first(usFmt),
      "Last": tpl.last(usFmt),
      "Sum over Sum": tpl.sumOverSum(usFmt),
      "80% Upper Bound": tpl.sumOverSumBound80(true, usFmt),
      "80% Lower Bound": tpl.sumOverSumBound80(false, usFmt),
      "Sum as Fraction of Total": tpl.fractionOf(tpl.sum(), "total", usFmtPct),
      "Sum as Fraction of Rows": tpl.fractionOf(tpl.sum(), "row", usFmtPct),
      "Sum as Fraction of Columns": tpl.fractionOf(tpl.sum(), "col", usFmtPct),
      "Count as Fraction of Total": tpl.fractionOf(tpl.count(), "total", usFmtPct),
      "Count as Fraction of Rows": tpl.fractionOf(tpl.count(), "row", usFmtPct),
      "Count as Fraction of Columns": tpl.fractionOf(tpl.count(), "col", usFmtPct)
    };
  })(aggregatorTemplates);

  renderers = {

  };

  // traduction string
  locales = {
    en: {
      aggregators: aggregators,
      renderers: renderers,
      localeStrings: {
        renderError: "An error occurred rendering the PivotTable results.",
        computeError: "An error occurred computing the PivotTable results.",
        uiRenderError: "An error occurred rendering the PivotTable UI.",
        selectAll: "Select All",
        selectNone: "Select None",
        tooMany: "(too many to list)",
        filterResults: "Filter values",
        apply: "Apply",
        cancel: "Cancel",
        totals: "Totals",
        vs: "vs",
        by: "by"
      }
    }
  };

  mthNamesEn = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  dayNamesEn = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

  zeroPad = function(number) {
    return ("0" + number).substr(-2, 2);
  };

  derivers = {
    bin: function(col, binWidth) {
      return function(record) {
        return record[col] - record[col] % binWidth;
      };
    },
    dateFormat: function(col, formatString, utcOutput, mthNames, dayNames) {
      var utc;
      if (utcOutput == null) {
        utcOutput = false;
      }
      if (mthNames == null) {
        mthNames = mthNamesEn;
      }
      if (dayNames == null) {
        dayNames = dayNamesEn;
      }
      utc = utcOutput ? "UTC" : "";
      return function(record) {
        var date;
        date = new Date(Date.parse(record[col]));
        if (isNaN(date)) {
          return "";
        }
        return formatString.replace(/%(.)/g, function(m, p) {
          switch (p) {
            case "y":
              return date["get" + utc + "FullYear"]();
            case "m":
              return zeroPad(date["get" + utc + "Month"]() + 1);
            case "n":
              return mthNames[date["get" + utc + "Month"]()];
            case "d":
              return zeroPad(date["get" + utc + "Date"]());
            case "w":
              return dayNames[date["get" + utc + "Day"]()];
            case "x":
              return date["get" + utc + "Day"]();
            case "H":
              return zeroPad(date["get" + utc + "Hours"]());
            case "M":
              return zeroPad(date["get" + utc + "Minutes"]());
            case "S":
              return zeroPad(date["get" + utc + "Seconds"]());
            default:
              return "%" + p;
          }
        });
      };
    }
  };

  rx = /(\d+)|(\D+)/g;
  rd = /\d/;
  rz = /^0/;
  naturalSort = (function(_this) {
    return function(as, bs) {
      var a, a1, b, b1, nas, nbs;
      if ((bs != null) && (as == null)) {
        return -1;
      }
      if ((as != null) && (bs == null)) {
        return 1;
      }
      if (typeof as === "number" && isNaN(as)) {
        return -1;
      }
      if (typeof bs === "number" && isNaN(bs)) {
        return 1;
      }
      nas = +as;
      nbs = +bs;
      if (nas < nbs) {
        return -1;
      }
      if (nas > nbs) {
        return 1;
      }
      if (typeof as === "number" && typeof bs !== "number") {
        return -1;
      }
      if (typeof bs === "number" && typeof as !== "number") {
        return 1;
      }
      if (typeof as === "number" && typeof bs === "number") {
        return 0;
      }
      if (isNaN(nbs) && !isNaN(nas)) {
        return -1;
      }
      if (isNaN(nas) && !isNaN(nbs)) {
        return 1;
      }
      // As date
      var isDateA = moment(String(as), ["DD-MM-YYYY"], true).isValid(); // true
      var isDateB = moment(String(bs), ["DD-MM-YYYY"], true).isValid(); // true
      if(isDateA && isDateB){
        dateA = moment(String(as), "DD-MM-YYYY");
        dateB = moment(String(bs), "DD-MM-YYYY");
        if(dateA.isBefore(dateB)){
          return -1;
        }else{
          return 1;
        }
      }

      // As String
      a = String(as);
      b = String(bs);
      if (a === b) {
        return 0;
      }
      if (!(rd.test(a) && rd.test(b))) {
        return (a > b ? 1 : -1);
      }
      a = a.match(rx);
      b = b.match(rx);
      while (a.length && b.length) {
        a1 = a.shift();
        b1 = b.shift();
        if (a1 !== b1) {
          if (rd.test(a1) && rd.test(b1)) {
            return a1.replace(rz, ".0") - b1.replace(rz, ".0");
          } else {
            return (a1 > b1 ? 1 : -1);
          }
        }
      }
      return a.length - b.length;
    };
  })(this);
  sortAs = function(order) {
    var i, l_mapping, mapping, x;
    mapping = {};
    l_mapping = {};
    for (i in order) {
      x = order[i];
      mapping[x] = i;
      if (typeof x === "string") {
        l_mapping[x.toLowerCase()] = i;
      }
    }
    return function(a, b) {
      if ((mapping[a] != null) && (mapping[b] != null)) {
        return mapping[a] - mapping[b];
      } else if (mapping[a] != null) {
        return -1;
      } else if (mapping[b] != null) {
        return 1;
      } else if ((l_mapping[a] != null) && (l_mapping[b] != null)) {
        return l_mapping[a] - l_mapping[b];
      } else if (l_mapping[a] != null) {
        return -1;
      } else if (l_mapping[b] != null) {
        return 1;
      } else {
        return naturalSort(a, b);
      }
    };
  };
  getSort = function(sorters, attr) {
    var sort;
    if (sorters != null) {
      if ($.isFunction(sorters)) {
        sort = sorters(attr);
        if ($.isFunction(sort)) {
          return sort;
        }
      } else if (sorters[attr] != null) {
        return sorters[attr];
      }
    }
    return naturalSort;
  };


  /*****************************
   *  Data Model class
   *****************************/
  PivotData = (function() {

    /*****************************/
    /***  Constructeur ***/
    /*****************************/
    function PivotData(input, opts) {

      //Passage par réference
      var ref;
      var ref1;
      var ref2;
      var ref3;
      var ref4;
      var ref5;
      var ref6;
      var ref7;
      var ref8;
      var ref9;

      if (opts == null) {
        opts = {};
      }

      this.getAggregator = bind(this.getAggregator, this);
      this.getRowKeys = bind(this.getRowKeys, this);
      this.getColKeys = bind(this.getColKeys, this);
      this.sortKeys = bind(this.sortKeys, this);
      this.arrSort = bind(this.arrSort, this);

      this.input = input;

      this.aggregator = (ref = opts.aggregator) != null ? ref : aggregatorTemplates.count()();
      this.aggregatorName = (ref1 = opts.aggregatorName) != null ? ref1 : "Count";
      this.colAttrs = (ref2 = opts.cols) != null ? ref2 : [];
      this.rowAttrs = (ref3 = opts.rows) != null ? ref3 : [];
      this.valAttrs = (ref4 = opts.vals) != null ? ref4 : [];
      this.sorters = (ref5 = opts.sorters) != null ? ref5 : {};
      this.rowOrder = (ref6 = opts.rowOrder) != null ? ref6 : "key_a_to_z";
      this.colOrder = (ref7 = opts.colOrder) != null ? ref7 : "key_a_to_z";
      this.derivedAttributes = (ref8 = opts.derivedAttributes) != null ? ref8 : {};
      this.filter = (ref9 = opts.filter) != null ? ref9 : (function() {
        return true;
      });

      this.tree = {};
      this.series = {};
      this.rowKeys = [];
      this.colKeys = [];
      this.rowTotals = {};
      this.colTotals = {};
      this.allTotal = this.aggregator(this, [], []);
      this.sorted = false;

      PivotData.forEachRecord(this.input, this.derivedAttributes, (function(_this) {
        return function(record) {
          if (_this.filter(record)) {
            return _this.processRecord(record);
          }
        };
      })(this));

    }

    // 1 - forEachRecord
    PivotData.forEachRecord = function(input, derivedAttributes, f) {

      var addRecord, compactRecord, i, j, k, l, len1, record, ref, results, results1, tblCols;

      if ($.isEmptyObject(derivedAttributes)) {
        addRecord = f;
      } else {
        addRecord = function(record) {
          var k, ref, v;
          for (k in derivedAttributes) {
            v = derivedAttributes[k];
            record[k] = (ref = v(record)) != null ? ref : record[k];
          }
          return f(record);
        };
      }

      if ($.isFunction(input)) {
        return input(addRecord);
      } else if ($.isArray(input)) {
        if ($.isArray(input[0])) {
          results = [];
          for (i in input) {
            if (!hasProp.call(input, i)) continue;
            compactRecord = input[i];
            if (!(i > 0)) {
              continue;
            }
            record = {};
            ref = input[0];
            for (j in ref) {
              if (!hasProp.call(ref, j)) continue;
              k = ref[j];
              record[k] = compactRecord[j];
            }
            results.push(addRecord(record));
          }
          return results;
        } else {
          results1 = [];
          for (l = 0, len1 = input.length; l < len1; l++) {
            record = input[l];
            results1.push(addRecord(record));
          }
          return results1;
        }
      } else if (input instanceof $) {
        tblCols = [];
        $("thead > tr > th", input).each(function(i) {
          return tblCols.push($(this).text());
        });
        return $("tbody > tr", input).each(function(i) {
          record = {};
          $("td", this).each(function(j) {
            return record[tblCols[j]] = $(this).text();
          });
          return addRecord(record);
        });
      } else {
        throw new Error("unknown input format");
      }

    };

    // 2 - forEachMatchingRecord
    PivotData.prototype.forEachMatchingRecord = function(criteria, callback) {
      return PivotData.forEachRecord(this.input, this.derivedAttributes, (function(_this) {
        return function(record) {
          var k, ref, v;
          if (!_this.filter(record)) {
            return;
          }
          for (k in criteria) {
            v = criteria[k];
            if (v !== ((ref = record[k]) != null ? ref : "null")) {
              return;
            }
          }
          return callback(record);
        };
      })(this));
    };

    // 3 - arrSort
    PivotData.prototype.arrSort = function(attrs) {
      var a, sortersArr;
      sortersArr = (function() {
        var l, len1, results;
        results = [];
        for (l = 0, len1 = attrs.length; l < len1; l++) {
          a = attrs[l];
          results.push(getSort(this.sorters, a));
        }
        return results;
      }).call(this);
      return function(a, b) {
        var comparison, i, sorter;
        for (i in sortersArr) {
          if (!hasProp.call(sortersArr, i)) continue;
          sorter = sortersArr[i];
          comparison = sorter(a[i], b[i]);
          if (comparison !== 0) {
            return comparison;
          }
        }
        return 0;
      };
    };

    // 4 - sortKeys
    PivotData.prototype.sortKeys = function() {
      var v;
      if (!this.sorted) {
        this.sorted = true;
        v = (function(_this) {
          return function(r, c) {
            return _this.getAggregator(r, c).value();
          };
        })(this);
        switch (this.rowOrder) {
          case "value_a_to_z":
            this.rowKeys.sort((function(_this) {
              return function(a, b) {
                return naturalSort(v(a, []), v(b, []));
              };
            })(this));
            break;
          case "value_z_to_a":
            this.rowKeys.sort((function(_this) {
              return function(a, b) {
                return -naturalSort(v(a, []), v(b, []));
              };
            })(this));
            break;
          default:
            this.rowKeys.sort(this.arrSort(this.rowAttrs));
        }
        switch (this.colOrder) {
          case "value_a_to_z":
            return this.colKeys.sort((function(_this) {
              return function(a, b) {
                return naturalSort(v([], a), v([], b));
              };
            })(this));
          case "value_z_to_a":
            return this.colKeys.sort((function(_this) {
              return function(a, b) {
                return -naturalSort(v([], a), v([], b));
              };
            })(this));
          default:
            return this.colKeys.sort(this.arrSort(this.colAttrs));
        }
      }
    };

    // 5 - getColKeys
    PivotData.prototype.getColKeys = function() {
      this.sortKeys();
      return this.colKeys;
    };

    // 6 - getRowKeys
    PivotData.prototype.getRowKeys = function() {
      this.sortKeys();
      return this.rowKeys;
    };

    // 7 - processRecord
    PivotData.prototype.processRecord = function(record) {

      //Creation des series simples
      for(var r in record) {
        if (!this.series[r]) {
          this.series[r] = [];
        }
        this.series[r].push(record[r]);
      }

      // Pivot data
      var colKey, flatColKey, flatRowKey, l, len1, len2, n, ref, ref1, ref2, ref3, rowKey, x;
      colKey = [];
      rowKey = [];

      ref = this.colAttrs;
      for (l = 0, len1 = ref.length; l < len1; l++) {
        x = ref[l];
        colKey.push((ref1 = record[x]) != null ? ref1 : "null");
      }

      ref2 = this.rowAttrs;
      for (n = 0, len2 = ref2.length; n < len2; n++) {
        x = ref2[n];
        rowKey.push((ref3 = record[x]) != null ? ref3 : "null");
      }

      flatRowKey = rowKey.join(String.fromCharCode(0));
      flatColKey = colKey.join(String.fromCharCode(0));

      this.allTotal.push(record);
      if (rowKey.length !== 0) {
        if (!this.rowTotals[flatRowKey]) {
          this.rowKeys.push(rowKey);
          this.rowTotals[flatRowKey] = this.aggregator(this, rowKey, []);
        }
        this.rowTotals[flatRowKey].push(record);
      }
      if (colKey.length !== 0) {
        if (!this.colTotals[flatColKey]) {
          this.colKeys.push(colKey);
          this.colTotals[flatColKey] = this.aggregator(this, [], colKey);
        }
        this.colTotals[flatColKey].push(record);
      }
      if (colKey.length !== 0 && rowKey.length !== 0) {
        if (!this.tree[flatRowKey]) {
          this.tree[flatRowKey] = {};
        }
        if (!this.tree[flatRowKey][flatColKey]) {
          this.tree[flatRowKey][flatColKey] = this.aggregator(this, rowKey, colKey);
        }
        return this.tree[flatRowKey][flatColKey].push(record);
      }
    };

    // 8 - getAggregator
    PivotData.prototype.getAggregator = function(rowKey, colKey) {
      var agg, flatColKey, flatRowKey;
      flatRowKey = rowKey.join(String.fromCharCode(0));
      flatColKey = colKey.join(String.fromCharCode(0));
      if (rowKey.length === 0 && colKey.length === 0) {
        agg = this.allTotal;
      } else if (rowKey.length === 0) {
        agg = this.colTotals[flatColKey];
      } else if (colKey.length === 0) {
        agg = this.rowTotals[flatRowKey];
      } else {
        agg = this.tree[flatRowKey][flatColKey];
      }
      return agg != null ? agg : {
        value: (function() {
          return null;
        }),
        format: function() {
          return "";
        }
      };
    };

    return PivotData;

  })();


  $.pivotUtilities = {
    aggregatorTemplates: aggregatorTemplates,
    aggregators: aggregators,
    renderers: renderers,
    derivers: derivers,
    locales: locales,
    naturalSort: naturalSort,
    numberFormat: numberFormat,
    sortAs: sortAs,
    PivotData: PivotData
  };


  /*
   Pivot Table core: create PivotData object and call Renderer on it
*/
  pivot = function(input, inputOpts, locale, that) {
    var defaults;
    var e;
    var localeDefaults;
    var localeStrings;
    var opts;
    var pivotData;
    var result;
    var x;

    //Gestion des langues
    if (locale == null) {
      locale = "en";
    }
    if (locales[locale] == null) {
      locale = "en";
    }
    localeStrings = $.extend(true, {}, locales.en.localeStrings, locales[locale].localeStrings);
    localeDefaults = {
      rendererOptions: {
        localeStrings: localeStrings
      },
      localeStrings: localeStrings
    };

    //Default Configuration
    defaults = {
      cols: [],
      rows: [],
      vals: [],
      rowOrder: "key_a_to_z",
      colOrder: "key_a_to_z",
      dataClass: PivotData,
      filter: function() {
        return true;
      },

      aggregator: aggregatorTemplates.count()(),
      aggregatorName: "Count",

      sorters: {},
      derivedAttributes: {},
      renderer: pivotTableRenderer
    };

    // Merge Option with default option
    opts = $.extend(true, {}, localeDefaults, $.extend({}, defaults, inputOpts));

    //Execution
    result = null;
    try {

      // Transformation et aggrégation des données
      pivotData = new opts.dataClass(input, opts);

      try {

        // draw data
        result = opts.renderer(pivotData, opts.rendererOptions);
      } catch (error) {
        e = error;
        if (typeof console !== "undefined" && console !== null) {
          console.error(e.stack);
        }
        result = $("<span>").html(opts.localeStrings.renderError);
      }
    } catch (error) {
      e = error;
      if (typeof console !== "undefined" && console !== null) {
        console.error(e.stack);
      }
      result = $("<span>").html(opts.localeStrings.computeError);
    }

    // Mettre la resultat dans le dom
    x = that[0];
    while (x.hasChildNodes()) {
      x.removeChild(x.lastChild);
    }
    return that.append(result);
  };


